import { AccountCard } from '../account/account_card.js';
import { services } from '../app/services.js';
import { session } from '../app/session.js';
import { PipeableObject } from '../base/pipeable/pipeable_object.js';

class Profile extends PipeableObject {
  get userid() {
    return this.data.id;
  }

  get name() {
    return this.data.name;
  }

  get email() {
    return this.data.email;
  }

  get avatar() {
    return this.data.avatar;
  }

  set(user) {
    super.set(new AccountCard(user || {}));
  }

  clear() {
    this.set({});
  }

  setAvatar(v) {
    this.setProperty('avatar', v);
    return services.profile.changeAvatar(v);
  }

  setName(v) {
    let avatar = this.avatar;
    this.setProperty('name', v);

    // Notify of avatar change if the name change altered avatar.
    if (avatar != this.avatar) {
      this.notify('avatar', this.avatar);
    }

    return services.profile.changeName(v);
  }

  setPassword(v) {
    return services.profile.changePassword(v);
  }

  constructor() {
    super();
    this.clear();
  }
}

const profile = new Profile();
session.hookOnChange(user => profile.set(user));

export { profile };
